//import ismagReducer from "../../modules/ismagquery/store/reducer"
//import { disclaimerReducer } from "../disclaimer/reducer"
// import filestoreListReducer from "../../modules/filestores/store/reducer"
// import profileReducer from "../../modules/profile/reducer"
// import settingReducer from "../../modules/settings/reducer"

import { Ismag } from "../../../openapi/ismag"



export type IsmagState = {
    searchDone: boolean
    ismagIssuers?: Ismag[]
    error? : string
    ismagSearchCriteria? : FormData
}


export  type IsmagAction =
    | {
      type: "Ismag/SEARCHDONE",
      payload: Ismag[]
      searchCriteria: FormData
    }
    | {
        type: "Ismag/RESETSEARCH"
    }
    | {
        type: "Ismag/FETCHERROR",
        payload: string
    }
    
  
    const initialState: IsmagState = { searchDone: false }

 


export    const ismagReducer = (
        state: IsmagState = initialState,
        action: IsmagAction 
    ) => {
        //console.log("in Ismag Reducer: state" + JSON.stringify(state)  + " tms:" + Date.now())
        switch (action.type) {
            case "Ismag/SEARCHDONE":
              return { ...state,  searchDone: true, ismagIssuers: action.payload, ismagSearchCriteria: action.searchCriteria }
            case "Ismag/RESETSEARCH" : {
                return { ...state,  searchDone: false }
            }
            case "Ismag/FETCHERROR" : {
                return { ...state,  searchDone: false, error: action.payload }
            }
              // case "IsmagCriteria/FETCHERROR" :    
            //     return {
            //         ...state,
            //         loading: false,
            //         error: action.payload,
            //       }

            default: return state
        }
    }
    